"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildKeyList = void 0;
/**
 * @param items
 * @returns a list of of numbers based on index of array omitting 0
 * [1,2,3,4,5]
 */
const buildKeyList = (items = []) => [
    ...Array(items.length + 1).keys()
];
exports.buildKeyList = buildKeyList;
